import { LOGOUT, SET_BID_REQUESTS, SET_OPEN_ORDERS, SET_PREVIOUS_ORDERS } from "../actionTypes";
export const SELLER_ACTION_TYPES = {
	GET_ORDERS_IN_PROGRESS: "GET_ORDERS_IN_PROGRESS",
	GET_ORDERS_IN_PROGRESS_DONE: "GET_ORDERS_IN_PROGRESS_DONE",
	GET_ORDERS_IN_PROGRESS_ERROR: "GET_ORDERS_IN_PROGRESS_ERROR",
	GET_ORDERS_IN_PROGRESS_ON_PAGE_CHANGE: "GET_ORDERS_IN_PROGRESS_ON_PAGE_CHANGE",
	GET_ORDERS_IN_PROGRESS_ON_PAGE_CHANGE_DONE: "GET_ORDERS_IN_PROGRESS_ON_PAGE_CHANGE_DONE",
	GET_ORDERS_IN_PROGRESS_ON_PAGE_CHANGE_ERROR: "GET_ORDERS_IN_PROGRESS_ON_PAGE_CHANGE_ERROR",
	GET_ORDERS_IN_PROGRESS_PER_PAGE_LIMIT_CHANGE: "GET_ORDERS_IN_PROGRESS_PER_PAGE_LIMIT_CHANGE",
	GET_ORDERS_IN_PROGRESS_PER_PAGE_LIMIT_CHANGE_DONE: "GET_ORDERS_IN_PROGRESS_PER_PAGE_LIMIT_CHANGE_DONE",
	GET_ORDERS_IN_PROGRESS_PER_PAGE_LIMIT_CHANGE_ERROR: "GET_ORDERS_IN_PROGRESS_PER_PAGE_LIMIT_CHANGE_ERROR",
	GET_ORDERS_IN_PROGRESS_FOR_SEARCHED_QUERY: "GET_ORDERS_IN_PROGRESS_FOR_SEARCHED_QUERY",
	GET_ORDERS_IN_PROGRESS_FOR_SEARCHED_QUERY_DONE: "GET_ORDERS_IN_PROGRESS_FOR_SEARCHED_QUERY_DONE",
	GET_ORDERS_IN_PROGRESS_FOR_SEARCHED_QUERY_ERROR: "GET_ORDERS_IN_PROGRESS_FOR_SEARCHED_QUERY_ERROR",
	GET_PREVIOUS_ORDERS: "GET_PREVIOUS_ORDERS",
	GET_PREVIOUS_ORDERS_DONE: "GET_PREVIOUS_ORDERS_DONE",
	GET_PREVIOUS_ORDERS_ERROR: "GET_PREVIOUS_ORDERS_ERROR",
	GET_PREVIOUS_ORDERS_ON_PAGE_CHANGE: "GET_PREVIOUS_ORDERS_ON_PAGE_CHANGE",
	GET_PREVIOUS_ORDERS_ON_PAGE_CHANGE_DONE: "GET_PREVIOUS_ORDERS_ON_PAGE_CHANGE_DONE",
	GET_PREVIOUS_ORDERS_ON_PAGE_CHANGE_ERROR: "GET_PREVIOUS_ORDERS_ON_PAGE_CHANGE_ERROR",
	GET_PREVIOUS_ORDERS_PER_PAGE_LIMIT_CHANGE: "GET_PREVIOUS_ORDERS_PER_PAGE_LIMIT_CHANGE",
	GET_PREVIOUS_ORDERS_PER_PAGE_LIMIT_CHANGE_DONE: "GET_PREVIOUS_ORDERS_PER_PAGE_LIMIT_CHANGE_DONE",
	GET_PREVIOUS_ORDERS_PER_PAGE_LIMIT_CHANGE_ERROR: "GET_PREVIOUS_ORDERS_PER_PAGE_LIMIT_CHANGE_ERROR",
	GET_PREVIOUS_ORDERS_FOR_SEARCHED_QUERY: "GET_PREVIOUS_ORDERS_FOR_SEARCHED_QUERY",
	GET_PREVIOUS_ORDERS_FOR_SEARCHED_QUERY_DONE: "GET_PREVIOUS_ORDERS_FOR_SEARCHED_QUERY_DONE",
	GET_PREVIOUS_ORDERS_FOR_SEARCHED_QUERY_ERROR: "GET_PREVIOUS_ORDERS_FOR_SEARCHED_QUERY_ERROR"
}

export const setBidRequests = (payload) => {

	return {
		type: SET_BID_REQUESTS,
		payload,
	};
};

export const setOpenOrders = (payload) => {

	return {
		type: SET_OPEN_ORDERS,
		payload,
	};
};

export const setPreviousOrders = (payload) => {

	return {
		type: SET_PREVIOUS_ORDERS,
		payload,
	};
};


export const resetSellerState = (payload) => {
	return {
		type: LOGOUT,
		payload,
	};
};

export const getOrdersInProgressAction = req => ({
	type: SELLER_ACTION_TYPES.GET_ORDERS_IN_PROGRESS,
	payload: req,
});

export const getOrdersInProgressDoneAction = req => ({
	type: SELLER_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_DONE,
	payload: req,
});

export const getOrdersInProgressErrorAction = req => ({
	type: SELLER_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_ERROR,
	payload: req,
});

export const getOrdersInProgressOnPageChangeAction = req => ({
	type: SELLER_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_ON_PAGE_CHANGE,
	payload: req,
});

export const getOrdersInProgressOnPageChangeDoneAction = req => ({
	type: SELLER_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_ON_PAGE_CHANGE_DONE,
	payload: req,
});

export const getOrdersInProgressOnPageChangeErrorAction = req => ({
	type: SELLER_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_ON_PAGE_CHANGE_ERROR,
	payload: req,
});

export const getOrdersInProgressPerPageLimitChangeAction = req => ({
	type: SELLER_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_PER_PAGE_LIMIT_CHANGE,
	payload: req,
});

export const getOrdersInProgressPerPageLimitChangeDoneAction = req => ({
	type: SELLER_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_PER_PAGE_LIMIT_CHANGE_DONE,
	payload: req
});

export const getOrdersInProgressPerPageLimitChangeErrorAction = req => ({
	type: SELLER_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_PER_PAGE_LIMIT_CHANGE_ERROR,
	payload: req
});

export const getOrdersInProgressForSearchedQueryAction = req => ({
	type: SELLER_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_FOR_SEARCHED_QUERY,
	payload: req,
});

export const getOrdersInProgressForSearchedQueryDoneAction = req => ({
	type: SELLER_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_FOR_SEARCHED_QUERY_DONE,
	payload: req,
});

export const getOrdersInProgressForSearchedQueryErrorAction = req => ({
	type: SELLER_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_FOR_SEARCHED_QUERY_ERROR,
	payload: req,
});

export const getPreviousOrdersAction = req => ({
	type: SELLER_ACTION_TYPES.GET_PREVIOUS_ORDERS,
	payload: req
});

export const getPreviousOrdersDoneAction = req => ({
	type: SELLER_ACTION_TYPES.GET_PREVIOUS_ORDERS_DONE,
	payload: req
});

export const getPreviousOrdersErrorAction = req => ({
	type: SELLER_ACTION_TYPES.GET_PREVIOUS_ORDERS_ERROR,
	payload: req
});

export const getPreviousOrdersOnPageChangeAction = req => ({
	type: SELLER_ACTION_TYPES.GET_PREVIOUS_ORDERS_ON_PAGE_CHANGE,
	payload: req
});

export const getPreviousOrdersOnPageChangeDoneAction = req => ({
	type: SELLER_ACTION_TYPES.GET_PREVIOUS_ORDERS_ON_PAGE_CHANGE_DONE,
	payload: req
});

export const getPreviousOrdersOnPageChangeErrorAction = req => ({
	type: SELLER_ACTION_TYPES.GET_PREVIOUS_ORDERS_ON_PAGE_CHANGE_ERROR,
	payload: req
});

export const getPreviousOrdersPerPageLimitChangeAction = req => ({
	type: SELLER_ACTION_TYPES.GET_PREVIOUS_ORDERS_PER_PAGE_LIMIT_CHANGE,
	payload: req
});

export const getPreviousOrdersPerPageLimitChangeDoneAction = req => ({
	type: SELLER_ACTION_TYPES.GET_PREVIOUS_ORDERS_PER_PAGE_LIMIT_CHANGE_DONE,
	payload: req
});

export const getPreviousOrdersPerPageLimitChangeErrorAction = req => ({
	type: SELLER_ACTION_TYPES.GET_PREVIOUS_ORDERS_PER_PAGE_LIMIT_CHANGE_ERROR,
	payload: req
});

export const getPreviousOrdersForSearchedQueryAction = req => ({
	type: SELLER_ACTION_TYPES.GET_PREVIOUS_ORDERS_FOR_SEARCHED_QUERY,
	payload: req
});

export const getPreviousOrdersForSearchedQueryDoneAction = req => ({
	type: SELLER_ACTION_TYPES.GET_PREVIOUS_ORDERS_FOR_SEARCHED_QUERY_DONE,
	payload: req
});

export const getPreviousOrdersForSearchedQueryErrorAction = req => ({
	type: SELLER_ACTION_TYPES.GET_PREVIOUS_ORDERS_FOR_SEARCHED_QUERY_ERROR,
	payload: req
});


export default {
	SELLER_ACTION_TYPES,
	getOrdersInProgressAction,
	getOrdersInProgressDoneAction,
	getOrdersInProgressErrorAction,
	getOrdersInProgressOnPageChangeAction,
	getOrdersInProgressOnPageChangeDoneAction,
	getOrdersInProgressOnPageChangeErrorAction,
	getOrdersInProgressPerPageLimitChangeAction,
	getOrdersInProgressPerPageLimitChangeDoneAction,
	getOrdersInProgressPerPageLimitChangeErrorAction,
	getOrdersInProgressForSearchedQueryAction,
	getOrdersInProgressForSearchedQueryDoneAction,
	getOrdersInProgressForSearchedQueryErrorAction,
	getPreviousOrdersAction,
	getPreviousOrdersDoneAction,
	getPreviousOrdersErrorAction,
	getPreviousOrdersOnPageChangeAction,
	getPreviousOrdersOnPageChangeDoneAction,
	getPreviousOrdersOnPageChangeErrorAction,
	getPreviousOrdersPerPageLimitChangeAction,
	getPreviousOrdersPerPageLimitChangeDoneAction,
	getPreviousOrdersPerPageLimitChangeErrorAction,
	getPreviousOrdersForSearchedQueryAction,
	getPreviousOrdersForSearchedQueryDoneAction,
	getPreviousOrdersForSearchedQueryErrorAction,
};